<template>
  <div class="bodyed">
    <span class="box">
      <!-- 头部 --> 
      <div class="box_title">
        <div class="left"><img style="width: 2.3rem;  transform: translateY(4px);" src="@/assets/kanban/kanban.png" alt=""></div>
        <div class="right">
          <span>{{nianyue}}</span>
          <span>{{xinqi}}</span>
          <span>{{timed}}</span>
          <img style="width: 0.4rem;margin-right: .1rem;margin-left: .4rem;" src="@/assets/kanban/tianqi.png" alt="">
          <span>珠海</span>
          <span>{{tianqi}}</span>
        </div>
      </div>
      <!-- 第二行 -->
      <div class="viewport">
        <div class="column">
          <!--概览-->

          <!--月出货量-->
          <div class="li">
            <div class="li_tit">
              <div class="name">月出货量</div>
              <div class="txt">Monthly delivery volume</div>
            </div>
            <div class="li_box">
              <div class="chart">
                <vchart class="vchart1" style="height: 87%; z-index: 2;" ref='vchart1'></vchart>
                 <div class="bgc">
                  <span style="width: .133rem;margin-right: -1px;"></span>
                  <span style="width: .134rem; "></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                 </div>
                <div class="bottomd">
                  <span>同比</span>
                  <span><img src="@/assets/kanban/shang.png" alt="">15%</span>
                  <span><img src="@/assets/kanban/shang.png" alt="">10%</span>
                  <span><img src="@/assets/kanban/xia.png" alt="">3%</span>
                  <span><img src="@/assets/kanban/shang.png" alt="">6%</span>
                  <span><img src="@/assets/kanban/shang.png" alt="">8%</span>
                  <span><img src="@/assets/kanban/xia.png" alt="">5%</span>
                  <span><img src="@/assets/kanban/shang.png" alt="">11%</span>
                </div>
              </div>
            </div>
          </div>


          <!-- 质量情况 -->
          <div class="li">
            <div class="li_tit">
              <div class="name">质量情况</div>
              <div class="txt">The quality of</div>
            </div>
            <div class="li_box">
              <div class="content" style="display: block; ">
                <div class="marquee-view2">
                  <div class="li">
                    <!-- 第一行表头 -->
                    <span></span>
                    <span>合格率</span>
                    <span>总数(台)</span>
                    <span>合格数(台)</span>
                  </div>
                  <!-- 内容 -->
                  <div class="li">
                    <span>开关柜</span>
                    <span>98%</span>
                    <span>1708</span>
                    <span>1674</span>
                  </div>
                  <div class="li">
                    <span>配电箱</span>
                    <span>98%</span>
                    <span>1708</span>
                    <span>1674</span>
                  </div>
                  <div class="li">
                    <span>母排</span>
                    <span>98%</span>
                    <span>1708</span>
                    <span>1674</span>
                  </div>
                  <div class="li">
                    <span>钣金</span>
                    <span>98%</span>
                    <span>1708</span>
                    <span>1674</span>
                  </div>
                  <div class="li">
                    <span>仓库</span>
                    <span>98%</span>
                    <span>1708</span>
                    <span>1674</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="column">
          <!-- 中间图片 -->
          <div class="map">
            <div class="m_box">
              <div class="li" style="margin-top: 0.13rem;">
                <div class="left"></div>
                <div class="right"></div>
                <div class="t">财年累计合同数</div>
                <div class="x"><span class="txt">{{cainian.leijihetong | spot_fn}}</span><span style=" line-height: .24rem;  ">份</span></div>
              </div>
              <div class="li">
                <div class="left"></div>
                <div class="right"></div>
                <div class="t">财年累计合同额</div>
                <div class="x"><span class="txt">{{cainian.leijijine | spot_fn}}</span><span style=" line-height: .24rem;  ">亿元</span></div>
              </div>
              <div class="li">
                <div class="left"></div>
                <div class="right"></div>
                <div class="t">财年累计产品数</div>
                <div class="x"><span class="txt">{{cainian.leijichanping | spot_fn}}</span><span style=" line-height: .24rem;  ">台</span></div>
              </div>
            </div>

            <!-- 右下角 -->
            <div class="LowerRightCorner">
              <div class="p">
                <div class="n">光伏发电量</div>
                <div class="t"><span>{{'2708' | spot_fn}}</span><i>Kwh</i></div>
              </div>
              <div class="p">
                <div class="n">充电桩用电量</div>
                <div class="t"><span>{{'269' | spot_fn}}</span><i>Kwh</i></div>
              </div>
              <div class="p">
                <div class="n">CO2减排量</div>
                <div class="t"><span>22. 7. 21</span><i>t</i></div>
              </div>
            </div>

            <img src="@/assets/kanban/m2.png" alt="" style="width: 100%;position: absolute;top: -.53rem;">
            <img style="width: 100%;margin-top:0.27rem;height: 100%; display: block;" src="@/assets/kanban/m3.png"
              alt="">
          </div>

        </div>
        <div class="column">
          <!--用能概况-->
          <div class="li">
            <div class="li_tit">
              <div class="name">用能概况</div>
              <div class="txt">Can use situation</div>
            </div>
            <div class="li_box">
              <div class="situation">
                <div class="p">
                  <div class="top">
                    <div class="l">今日用电</div>
                    <div class="m">
                      <div class="txt">96541</div>kwh
                    </div>
                    <div class="r">
                      <div class="n">0.33%</div>
                      <div class="n">▲</div>
                    </div>
                  </div>
                  <div class="bottom">昨日同期用电：96340kwh</div>
                </div>
                <div class="p">
                  <div class="top">
                    <div class="l">当月用电</div>
                    <div class="m">
                      <div class="txt">496246</div>kwh
                    </div>
                    <div class="r Reverse">
                      <div class="n">0.92%</div>
                      <div class="n">▲</div>
                    </div>
                  </div>
                  <div class="bottom">上月同期用电：455423kwh</div>
                </div>
                <div class="p">
                  <div class="top">
                    <div class="l">当年用电</div>
                    <div class="m">
                      <div class="txt">3485423</div>kwh
                    </div>
                    <div class="r none">
                      <div class="n">—</div>
                    </div>
                  </div>
                  <div class="bottom">上年同期用电：0kwh</div>
                </div>
              </div>
            </div>
          </div>
          <!--区域能耗-->
          <div class="li">
            <div class="li_tit">
              <div class="name">区域能耗</div>
              <div class="txt">Itemized energy consumption</div>
            </div>
            <div class="li_box ">
              <div class="Itemized">
                <div class="p" v-for="(e,index) in  fenxiang_datqa" :key="index">
                  <div class="name">{{e.name}}</div>
                  <div class="jindu">
                    <div class="n" :style="{width:e.percentage + '%'}"></div>
                  </div>
                  <div class="text">{{e.percentage}}%</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- 第三行-->
      <span class="bottom_box bottom_box1">
        <!-- 在产数量 -->
        <div class="li">
          <div class="li_tit">
            <div class="name">在产数量</div>
            <div class="txt">Quantity in production</div>
          </div>
          <div class="li_box2">
            <div class="zaichan">
              <div class="titled">
                <div class="n">配电箱</div>
                <div class="t">1708</div>
                <div class="n">开关柜</div>
                <div class="t">269</div>
                <div class="n">同比增长</div>
                <div class="t" style="color: #CB8429;">33%</div>
              </div>
              <div class="content">
                <div class="left" style="margin-right: 0.3rem; ">
                  <div class="progress_box">
                    <el-progress type="circle" :width="75" :stroke-width="4" :percentage="65" stroke-linecap="butt"
                      color="#1E74BB"></el-progress>
                  </div>
                  <span class="name">配电箱</span>
                </div>
                <div class="right">
                  <div class="progress_box">
                    <el-progress type="circle" :width="75" :stroke-width="4" :percentage="35" stroke-linecap="butt"
                      color="#58B6DF"></el-progress>
                  </div>
                  <span class="name">开关柜</span>
                </div>
              </div>
            </div>
          </div>
        </div>



        <!-- 负荷曲线 -->
        <div class="li">
          <div class="li_tit">
            <div class="name">负荷曲线</div>
            <div class="txt">Load curve</div>
          </div>
          <div class="li_box22" style="    box-sizing: border-box;padding: .1rem;">
            <vchart style="height: 100%;" ref='curve1'></vchart>
          </div>
        </div>
        <!-- 生产能耗 -->
        <div class="li">
          <div class="li_tit">
            <div class="name">生产能耗</div>
            <div class="txt">Production energy consumption</div>
          </div>
          <div class="li_box2">
            <div class="Itemized">
              <div class="p" v-for="(e,index) in  shengchan_datqa" :key="index">
                <div class="name">{{e.name}}</div>
                <div class="jindu">
                  <div class="n" :style="{width:e.percentage + '%'}"></div>
                </div>
                <div class="text">{{e.percentage}}%</div>
              </div>
            </div>
          </div>
        </div>
      </span>
      <!-- 第四行 -->
      <span class="bottom_box">
        <!-- 合同签订 -->
        <div class="li" style="flex: 1;margin-right: 25px;">
          <div class="li_tit">
            <div class="name">合同签订</div>
            <div class="txt">Contract signing</div>
          </div>
          <div class="li_box3">
            <div class="hetong">
              <div class="left">
                <div class="titled">
                  <div class="n">金额</div>
                  <div class="t">{{'5.45' | spot_fn}}<i>亿元</i></div>
                  <div class="n">台数</div>
                  <div class="t">{{'4.74' | spot_fn}}<i>万台</i></div>
                  <div class="n">已完成</div>
                  <div class="t">{{'3.9' | spot_fn}}<i>万台</i></div>
                </div>
                <vchart class="Unfilled1" ref='Unfilled1'></vchart>
              </div>
              <div class="right">
                <div class="titled">
                  <div class="n">排产订单</div>
                  <div class="t">85<i>项</i></div>
                  <div class="n">计划</div>
                  <div class="t">70<i>项</i></div>
                </div>
                <vchart class="Unfilled2" ref='Unfilled2'></vchart>
              </div>
            </div>

          </div>
        </div>
        <!-- 同期对比 -->
        <div class="li" style="flex: 1;">
          <div class="li_tit">
            <div class="name">同期对比</div>
            <div class="txt">At the same time comparing</div>
          </div>
          <div class="li_box3 li_box4">
            <div class="comparing">
              <div class="left">
                <div class="tit">人均产值 <div class="txt">{{compareData.renjun}}</div><span
                    style=" font-size: .1rem;transform: translateY(0.03rem); ">万元</span></div>
                <vchart style="height: 100%;" ref='comparing1'></vchart>
                <span class="span"><i class="el-icon-top"></i>{{compareData.pieData}}%</span>
              </div>
              <div class="right">
                <div class="li">
                  <div class="t">
                    <div class="n">人均效能</div>
                    <div class="ll">
                      <span class="nn">去年同期</span>
                      <span class="nt">
                        <span class="txt">{{compareData.lastleiji}}</span><span class="ren">Kwh</span>
                      </span>
                    </div>
                  </div>
                  <div class="t">
                    <div class="n"><span class="txt">{{compareData.leiji}}</span><span class="ren">Kwh</span></div>
                    <div class="ll">
                      <span class="nn">去年同期相比</span>
                      <span class="nt" v-if="compareStatus.leijiUp">
                        <span>▲</span><span>{{compareData.leijiRate}}%</span>
                      </span>
                      <span class="nt" v-if="compareStatus.leijiDown">
                        <span
                          style="transform: rotate(180deg);display: inline-block;color: #1ab49c;">▲</span><span>{{compareData.leijiRate}}%</span>
                      </span>
                      <span class="nt" v-if="compareStatus.leijiTie">
                        <span class="n">-</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="li">
                  <div class="t">
                    <div class="n">单位产品能耗</div>
                    <div class="ll">
                      <span class="nn">去年同期</span>
                      <span class="nt">
                        <span class="txt">{{compareData.lastchanshu}}</span><span class="ren">Kwh</span>
                      </span>
                    </div>
                  </div>
                  <div class="t">
                    <div class="n"><span class="txt">{{compareData.zaichanshu}}</span><span class="ren">Kwh</span></div>
                    <div class="ll">
                      <span class="nn">去年同期相比</span>
                      <span class="nt" v-if="compareStatus.chanshuUp">
                        <span>▲</span><span>{{compareData.chanshuRate}}%</span>
                      </span>
                      <span class="nt" v-if="compareStatus.chanshuDown">
                        <span
                          style="transform: rotate(180deg);display: inline-block;color: #1ab49c;">▲</span><span>{{compareData.renshuRate}}%</span>
                      </span>
                      <span class="nt" v-if="compareStatus.chanshuTie">
                        <span class="n">-</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="li">
                  <div class="t">
                    <div class="n">人均出勤</div>
                    <div class="ll">
                      <span class="nn">去年同期</span>
                      <span class="nt">
                        <span class="txt">{{compareData.lastrenshu}}</span><span class="ren">人</span>
                      </span>
                    </div>
                  </div>
                  <div class="t">
                    <div class="n"><span class="txt">{{compareData.renshu}}</span><span class="ren">人</span></div>
                    <div class="ll">
                      <span class="nn">去年同期相比</span>
                      <span class="nt" v-if="compareStatus.renshuUp">
                        <span>▲</span><span>{{compareData.renshuRate}}%</span>
                      </span>
                      <span class="nt" v-if="compareStatus.renshuDown">
                        <span
                          style="transform: rotate(180deg);display: inline-block;color: #1ab49c;">▲</span><span>{{compareData.renshuRate}}%</span>
                      </span>
                      <span class="nt" v-if="compareStatus.renshuTie">
                        <span class="n">-</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="li">
                  <div class="t">
                    <div class="n">产值能耗</div>
                    <div class="ll">
                      <span class="nn">去年同期</span>
                      <span class="nt">
                        <span class="txt">{{compareData.lasthetong}}</span><span class="ren">Kwh</span>
                      </span>
                    </div>
                  </div>
                  <div class="t">
                    <div class="n"><span class="txt">{{compareData.hetong}}</span><span class="ren">Kwh</span></div>
                    <div class="ll">
                      <span class="nn">去年同期相比</span>
                      <span class="nt" v-if="compareStatus.hetongUp">
                        <span>▲</span><span>{{compareData.hetongRate}}%</span>
                      </span>
                      <span class="nt" v-if="compareStatus.hetongDown">
                        <span
                          style="transform: rotate(180deg);display: inline-block;color: #1ab49c;">▲</span><span>{{compareData.hetongRate}}%</span>
                      </span>
                      <span class="nt" v-if="compareStatus.hetongTie">
                        <span class="n">-</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    </span>
  </div>
</template>

<script>
  import vchart from '@/components/module/chart/vchart.vue'
  export default {
    components: {
      vchart
    },
    data() {
      return {
        compareData: {
          renjun: 50, pieData: 30, leiji: 1745, lastleiji: 1245, renshu: 95, lastrenshu: 89, zaichanshu: 1612, lastchanshu: 1545, hetong: 122554, lasthetong: 100435,
          leijiRate: 9.4, chanshuRate: 58.78, renshuRate: 8.6, hetongRate: 27.36
        },//同期对比
        compareStatus: {
          leijiUp: true, leijiDown: false, leijiTie: false, chanshuUp: true, chanshuDown: false, chanshuTie: false,
          renshuUp: true, renshuDown: false, renshuTie: false, hetongUp: true, hetongDown: false, hetongTie: false
        },//同期对比状态
        producingNum: { pdx: 0, gyg: 0, dyg: 0 },//在产数量
        workShopNum: { gyg: 0, dyg: 0, bj: 0, mxc: 0, pdx: 0, renshu: 0, total: 0 },//人均出勤
        cainian: { //财年
          leijihetong: 554,
          leijijine: '5.45',
          leijichanping: '40,745',
        },
        timed: '',//时间
        tianqi: '',//天气
        xinqi: '',
        nianyue: '',
        fenxiang_datqa: [],//分项数据
        shengchan_datqa: [],//生产能耗数据
      }
    },
    filters: {
      //给数字添加空格
      spot_fn(v){
          v =  v.toString()
        var d = v.indexOf('.');
        if (d != -1) {
          var a =v.slice(0,d+1)+' ' + v.slice(d+1) 
         return a
        }else if (v.indexOf(',') != -1) {
          d =v.indexOf(',');
          var a =v.slice(0,d+1)+' ' + v.slice(d+1) 
         return a
        }
        return v
      }
    },
    mounted() {

      setFz();
      //  屏幕的宽度改变之后 
      window.onresize = function () {
        setFz();
      }
      function setFz() {
        /* 
        1 获取到当前的屏幕的宽度  =  要适配的屏幕的宽度
        2 计算html字体的大小   fontsize=基础值 * 要适配的屏幕的宽度 /  设计稿的宽度
        3 打开页面 直接调用该方法  屏幕的宽度改变之后 再调用一次这个方法 就可以动态改变html的字体
         */

        // 当前屏幕的宽度
        var screenWidth = document.querySelector("html").offsetWidth;
        // 基础值
        var baseVal = 100;
        // 设计稿的宽度
        var pageWidth = 1920;
        // 字体大小
        var fz = baseVal * screenWidth / pageWidth;

        document.querySelector("html").style.fontSize = fz + "px";

      }


      // 天气
      setInterval(() => { 
        this.nianyue = this.parseTime(new Date(), '{y}/{m}/{d}');
        this.xinqi = this.parseTime(new Date(), '星期{a}');
        this.timed = this.parseTime(new Date(), '{h}：{i}：{s}');
      }, 1000);
      var url = encodeURI("http://wthrcdn.etouch.cn/weather_mini?city=珠海市");
      $.get({
        url: url,
        dataType: "json",
        async: false,
        success: (data) => {
          var d = data.data.forecast[0];
          var e = new Date().getDay()
          this.tianqi = d.type + ', ' + d.high.slice(3, 5) + '~' + d.low.slice(-3);

        }
      })


      // 在产数量
      this.zaichanNum();
      // 同期对比
      this.comparing();
      // 负荷曲线
      this.curve();
      // 月出货量
      this.yonghu();
      // 合同签订
      this.Unfilled();
      this.Unfilled2();
      // 定单
      this.dingdan();
      // 区域能耗
      this.quyu()

      // mounte里隐藏边框
      this.$store.menuStore.commit("setTopMenuEnable", false)
      this.$store.menuStore.commit("setLeftMenuEnable", false)

       //财年数据
          this.getRealTimeValue();

    },
    methods: {
      //财年数据
      getRealTimeValue() {
        
        this.$api.realApi.getMACRealValueWithID('财年累计合同数,财年累计合同额,财年累计产品数', '', res => {
          let strArr = res.data.split(";");
          this.cainian.leijihetong = strArr[0];
          this.cainian.leijijine = strArr[1];
          this.cainian.leijichanping = strArr[2];
        })
        //获取在产数量
        this.$api.realApi.getMACRealValueWithID('在产数量.配电箱,在产数量.高压柜,在产数量.低压柜', '', res => {
          let strArr = res.data.split(";");
          this.producingNum.pdx = strArr[0];
          this.producingNum.gyg = strArr[1];
          this.producingNum.dyg = strArr[2];
          let data = [];
          data.push({ value: strArr[0], name: '配电箱' });
          data.push({ value: strArr[1], name: '高压柜' });
          data.push({ value: strArr[2], name: '低压柜' });
          this.fenbuOption.series[0].data = data;
          this.$refs.vchart2.setData(this.fenbuOption, true);
        })
        //获取车间人数
        this.$api.realApi.getMACRealValueWithID('人均出勤.高低压车间,人均出勤.配电箱车间,人均出勤.母线铜排车间,人均出勤.钣金车间', '', res => {
          let strArr = res.data.split(";");
          this.workShopNum.gyg = strArr[0];
          this.workShopNum.dyg = strArr[1];
          this.workShopNum.bj = strArr[2];
          this.workShopNum.mxc = strArr[3];
          this.workShopNum.pdx = strArr[4];
          this.workShopNum.total = Number(strArr[0]) + Number(strArr[1]) + Number(strArr[2]) + Number(strArr[3]) + Number(strArr[4]);

        })
        //同期对比
        this.$api.realApi.getMACRealValueWithID('同期对比.人均产值,同期对比.增长率,同期对比.累计出货,同期对比.去年同期出货,同期对比.在产数,同期对比.去年在产数,' +
          '同期对比.人均出勤,' + '同期对比.去年车间人数,同期对比.产值能耗,同期对比.去年已签合同', '', res => {
            let strArr = res.data.split(";");
            this.compareData.renjun = strArr[0];     //人均产值
            this.compareData.pieData = strArr[1];    //增长率
            this.compareData.leiji = strArr[2];      //累计出货
            this.compareData.lastleiji = strArr[3];  //去年累计出货
            this.compareData.renshu = strArr[6];  //人均出勤
            this.compareData.lastrenshu = strArr[7]; //去年同期人数
            this.compareData.zaichanshu = strArr[4]; //同期在产数
            this.compareData.lastchanshu = strArr[5];//去年在产数
            this.compareData.hetong = strArr[8];     //产值能耗
            this.compareData.lasthetong = strArr[9]; //去年已签合同

            //计算比例
            //在产数
            let chanshuCha = Number(strArr[4]) - Number(strArr[5]);//产数差值
            if (isempty(strArr[5]) || Number(strArr[5]) == 0) {
              this.compareStatus.chanshuTie = true;
            } else {
              if (chanshuCha > 0) {
                this.compareStatus.chanshuUp = true;
              } else if (chanshuCha < 0) {
                this.compareStatus.chanshuDown = true;
              } else {
                this.compareStatus.chanshuTie = true;
              }
              this.compareData.chanshuRate = ((Math.abs(chanshuCha / strArr[5])) * 100).toFixed(2);
            }
            //出货
            let leijiCha = Number(strArr[2]) - Number(strArr[3]);//出货差值
            //debugger
            if (isempty(strArr[3]) || Number(strArr[3]) == 0) {
              this.compareStatus.leijiTie = true;
            } else {
              if (leijiCha > 0) {
                this.compareStatus.leijiUp = true;
              } else if (leijiCha < 0) {
                this.compareStatus.leijiDown = true;
              } else {
                this.compareStatus.leijiTie = true;
              }
              this.compareData.leijiRate = ((Math.abs(leijiCha / strArr[3])) * 100).toFixed(2);
            }
            //人均出勤
            let renshuCha = Number(strArr[6]) - Number(strArr[7]);//人数差值
            if (isempty(strArr[7]) || Number(strArr[7]) == 0) {
              this.compareStatus.renshuTie = true;
            } else {
              if (renshuCha > 0) {
                this.compareStatus.renshuUp = true;
              } else if (renshuCha < 0) {
                this.compareStatus.renshuDown = true;
              } else {
                this.compareStatus.renshuTie = true;
              }
              this.compareData.renshuRate = ((Math.abs(renshuCha / strArr[7])) * 100).toFixed(2);
            }
            //合同数
            let hetongCha = Number(strArr[8]) - Number(strArr[9]);//人数差值
            if (isempty(strArr[9]) || Number(strArr[9]) == 0) {
              this.compareStatus.hetongTie = true;
            } else {
              if (hetongCha > 0) {
                this.compareStatus.hetongUp = true;
              } else if (hetongCha < 0) {
                this.compareStatus.hetongDown = true;
              } else {
                this.compareStatus.hetongTie = true;
              }
              this.compareData.hetongRate = ((Math.abs(hetongCha / strArr[9])) * 100).toFixed(2);
            }

          })

      },


      // 区域能耗
      quyu() {

        var d = {
          "data": [{
            percentage: '95',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "研发中心",
          }, {
            percentage: '15',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "母线槽车间",
          }, {
            percentage: '20',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "物流中心",
          }, {
            percentage: '45',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "成套车间",
          }, {
            percentage: '35',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "宿舍楼",
          }, {
            percentage: '25',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "钣金车间",
          },],
        };
        // d.data.map(v => {
        //   // 百分比的计算方法:数量÷总数×100=百分比
        //   v.percentage = Math.round(v.now / v.data * 10000) / 100 //保留两位小数
        // })
        this.fenxiang_datqa = d.data;


        //  生产能耗数据
        var b = {
          "data": [{
            percentage: '60',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "一层",
          }, {
            percentage: '75',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "二层",
          }, {
            percentage: '60',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "三层",
          }, {
            percentage: '80',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "四层",
          }, {
            percentage: '30',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "五层",
          }, {
            percentage: '20',//百分比
            now: 1000,//实数
            "data": 2359.18,//总数
            "createTime": null,
            "name": "六层",
          },],
        };
        this.shengchan_datqa = b.data;
      },
      parseTime(time, cFormat) {
        if (arguments.length === 0) {
          return null
        }
        const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
          date = time
        } else {
          if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
          }
          if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
          }
          date = new Date(time)
        }
        const formatObj = {
          y: date.getFullYear(),
          m: date.getMonth() + 1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
          const value = formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
          return value.toString().padStart(2, '0')
        })
        return time_str
      },
      // 合同签订
      Unfilled() {
        // var d = []
        // for (let i = 1; i < 13; i++) {
        //   d.push(i + '月') 
        // }
        var month = new Date().getMonth() + 1; // 7
        var d = []
        for (let i = 0; i < 5; i++) {
          d.push( month + i + '月') 
        }
        var option = {
          legend: {
            textStyle: {
              fontSize: 12,//字体大小
              color: '#ccc'//字体颜色
            },
            orient: 'vertical',
            right: 10,
            top: 30,
            data: [
              {
                name: '计划中',
                lineStyle: {
                  width: 22
                },
                icon: 'image://data:image/png;base64,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'
              },
              {
                name: '未进入',
                textStyle: {

                },
                icon: 'image://data:image/png;base64,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'
              }
            ],
            itemWidth: 11,  // 设置宽度 
            itemHeight: 11, // 设置高度
          },
          // 工具提示
          tooltip: {
            // 触发类型  经过轴触发axis  经过轴触发item
            trigger: 'item',
            // 轴触发提示才有效
            axisPointer: {
              // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果       
              type: 'shadow'
            }
          },
          // 图表边界控制
          grid: {
            // 距离 上右下左 的距离
            left: '1%',
            right: '19.7%',
            bottom: '4%',
            top: '23%',
            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
          },
          // 控制x轴
          xAxis: [
            {
              data: d,
              // 使用数据的值设为刻度文字
              type: 'category',
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: true,
                show: false
              },
              //文字
              axisLabel: {
                color: "#667079",
                interval: 0,
                fontSize: 9,
                formatter: function (params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 15;
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                  if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = "";
                      var start = p * provideNumber;
                      var end = start + provideNumber;
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        tempStr = params.substring(start, end) + "\n";
                      }
                      newParamsName += tempStr;
                    }

                  } else {
                    newParamsName = params;
                  }
                  return newParamsName
                }
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 0, 0, 0.2)'
                }
              },
            }


          ],
          // 控制y轴
          yAxis: [
            {
              name: '数量',
              nameTextStyle: {
                fontSize: 9,
                lineHeight: 0,
                color:'#8B99A6', 
                rich: {
                  a: {
                    // 没有设置 `lineHeight`，则 `lineHeight` 为 56
                  }
                }
              },
              // 使用类目，必须有data属性
              type: 'value',
              // 使用 data 中的数据设为刻度文字
              max: function (value) {
                return value.max + 100;
              },
              // 刻度设置
              axisTick: {
                show: false,
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: false,
                show: false
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 0, 0, 0.2)'
                }
              },
              //文字
              axisLabel: {
                color: "#667079",
                interval: 0,
                fontSize: 9,
                formatter: function (params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 15;
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                  if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = "";
                      var start = p * provideNumber;
                      var end = start + provideNumber;
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        tempStr = params.substring(start, end) + "\n";
                      }
                      newParamsName += tempStr;
                    }

                  } else {
                    newParamsName = params;
                  }
                  return newParamsName
                }
              },
            }
          ],
          color: ['#1e74bb', '#cb8429', '#58b6df'], //柱子颜色
          // 控制x轴
          series: [
            {
              // series配置 
              // 图表数据名称
              name: '计划中',

              // 图表类型
              type: 'bar',
              barWidth: 12, // 柱子宽度
              barGap: 0,
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              label: {
                show: true,
                position: 'top',
                fontSize: 9 ,
                color: '#CCC' ,
              },
              // 数据
              data: [153, 200, 223,415,243]
            },
            {
              // series配置 
              // 图表数据名称
              name: '未进入',
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              label: {
                show: true,
                position: 'top',
                fontSize: 9 ,
                color: '#CCC' ,
              },
              // 图表类型
              type: 'bar',
              barWidth: 12, // 柱子宽度
              barGap: 0,
              // 数据
              data: [153, 190, 213,98,163]
            }
          ]
        }; 
        this.$refs.Unfilled1.setData(option, true);


      }, 
      // 合同签订
      Unfilled2() {
        var month = new Date().getMonth() + 1; // 7
        var d = []
        for (let i = 0; i < 3; i++) {
          d.push( month + i + '月') 
        }
        var option = {
          legend: {
            textStyle: {
              fontSize: 12,//字体大小
              color: '#ccc'//字体颜色
            },
            orient: 'vertical',
            right: 10,
            top: 30,
            data: [
              {
                name: '订单',
                lineStyle: {
                  width: 22
                },
                icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAoCAYAAAB0HkOaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpBMEI5QUY1MDBEMDFFRDExQUZENkIyOUY0NThGMTQxNiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo4MTU1MTRGNjIzNEMxMUVEQkRGRkYxNjMxNzc3NTY4OSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo4MTU1MTRGNTIzNEMxMUVEQkRGRkYxNjMxNzc3NTY4OSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxYjdhYmRjMS1iYzJkLWEzNDgtYWVhNi01NzAwNzEzYjdkYTkiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo2YTliMGJlNC02Nzc5LTAzNGUtOGM4NC1jM2JiYmEyNjEwNDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6N5PvBAAAA9klEQVR42mLkLvzOQABUAXEtEHMwkA9+AHEzELfhU8RIwDFyQPwApI6BcvAfiBWA+BEuBUxAHADEr6GKQfgDmmNADtkKpcnFMP1ySGZfQrITZL8vyDHTgFiEYWAByP6ZLEBCEog/ArEAFkWPoC73htKURhNyFOkhsUGxIclEwACQ5mog/kahQ75DzXlEKAH/xxMy9AKgkOFnYhhEYNQxo46htmNskEpJSrD3kAsZFgLyR6hUSY4m4NHcRAhnDvmQGc1No44ZzU2juWnUMaOOGXXMqGNGHTNcHQOqm14BsRgD5SNTlIJXoJBJB+K3A+yQNyB3AAQYAHmqWXiG/AcyAAAAAElFTkSuQmCC'
              },
              {
                name: '计划',
                textStyle: {

                },
                icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAoCAYAAAB0HkOaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpBMEI5QUY1MDBEMDFFRDExQUZENkIyOUY0NThGMTQxNiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo4MTYxMzM4MzIzNEMxMUVEQkRGRkYxNjMxNzc3NTY4OSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo4MTYxMzM4MjIzNEMxMUVEQkRGRkYxNjMxNzc3NTY4OSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxYjdhYmRjMS1iYzJkLWEzNDgtYWVhNi01NzAwNzEzYjdkYTkiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo2YTliMGJlNC02Nzc5LTAzNGUtOGM4NC1jM2JiYmEyNjEwNDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7Yk8h+AAAA8UlEQVR42mI83aLJQABUAXEtEHMwkA9+AHEzELfhU8REwBA5IG6h0CEMUP0tUPPwOiYAiF8D8X8o/oDmGEYg3gqlycUw/ciOuYRkJ8h+X5BjpgGxCMPAApD9M1mAhCQQfwRiASyKHkFd7g2lKQH/oebBgB4SGxQbkoTSDEhzNRB/o9Ah36HmPMKniIUIg9qhmOaAiWEQgVHHjDqG2o6xQSolKcHeQy5kCJUzR6B1ymiaGXUMrXNT5pAPmdHcNOqY0dw0mptGHTPqmFHHjDpm1DHD1TGguukVEIsxUD4yRSl4BQqZdCB+O8AOeQNyB0CAAQC9L1L+lhzcTQAAAABJRU5ErkJggg=='
              }
            ],
            itemWidth: 11,  // 设置宽度 
            itemHeight: 11, // 设置高度
          },
          // 工具提示
          tooltip: {
            // 触发类型  经过轴触发axis  经过轴触发item
            trigger: 'item',
            // 轴触发提示才有效
            axisPointer: {
              // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果       
              type: 'shadow'
            }
          },
          // 图表边界控制
          grid: {
            // 距离 上右下左 的距离
            left: '1%',
            right: '22%',
            bottom: '4%',
            top: '23%',

            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
          },
          // 控制x轴
          xAxis: [
            {
              data: d,
              // 使用数据的值设为刻度文字
              type: 'category',
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: true,
                show: false
              },
              //文字
              axisLabel: {
                color: "#667079",
                interval: 0,
                fontSize: 9,
                formatter: function (params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 15;
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                  if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = "";
                      var start = p * provideNumber;
                      var end = start + provideNumber;
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        tempStr = params.substring(start, end) + "\n";
                      }
                      newParamsName += tempStr;
                    }

                  } else {
                    newParamsName = params;
                  }
                  return newParamsName
                }
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 0, 0, 0.2)'
                }
              },
            }


          ],
          // 控制y轴
          yAxis: [
            {
              name: '数量',
              nameTextStyle: {
                fontSize: 9,
                lineHeight: 0,
                color:'#8B99A6',
                rich: {
                  a: {
                    // 没有设置 `lineHeight`，则 `lineHeight` 为 56
                  }
                }
              },
              // 使用类目，必须有data属性
              type: 'value',
              // 使用 data 中的数据设为刻度文字
              max: function (value) {  
                if (value.max<100) {
                  return 100
                }
                return  value.max
              },
              // 刻度设置
              axisTick: {
                show: false,
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: false,
                show: false
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 0, 0, 0.2)'
                }
              },
              //文字
              axisLabel: {
                color: "#667079",
                interval: 0,
                fontSize: 9,
                formatter: function (params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 15;
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                  if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = "";
                      var start = p * provideNumber;
                      var end = start + provideNumber;
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        tempStr = params.substring(start, end) + "\n";
                      }
                      newParamsName += tempStr;
                    }

                  } else {
                    newParamsName = params;
                  }
                  return newParamsName
                }
              },
            }
          ],
          color: ['#1e74bb', '#cb8429', '#58b6df'], //柱子颜色
          // 控制x轴
          series: [
            {
              // series配置 
              // 图表数据名称
              name: '订单',
              // 图表类型
              type: 'bar',
              barWidth: 12, // 柱子宽度
              barGap: 0,
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              label: {
                show: true,
                position: 'top',
                fontSize: 9 ,
                color: '#CCC' ,
              },
              // 数据
              data: [53, 20, 23]
            },
            {
              // series配置 
              // 图表数据名称
              name: '计划',
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              label: {
                show: true,
                position: 'top',
                fontSize: 9 ,
                color: '#CCC' ,
              },
              // 图表类型
              type: 'bar',
              barWidth: 12, // 柱子宽度
              barGap: 0,
              // 数据
              data: [50, 15, 13]
            }
          ]
       
        };

        this.$refs.Unfilled2.setData(option, true);


      },
      // 月出货量
      yonghu() {
        var d = []
        for (let i = 1; i < 13; i++) {
          d.push(i + '月');
        }
        var option = {
          legend: {
            textStyle: {
              fontSize: 9,//字体大小
              color: '#ccc'//字体颜色
            },
            top: -4,
            left: 'right',
            icon: "rect",   //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 7,  // 设置宽度 
            itemHeight: 5, // 设置高度
          },
          // 工具提示
          tooltip: {
            // 触发类型  经过轴触发axis  经过轴触发item
            trigger: 'item',
            // 轴触发提示才有效
            axisPointer: {
              // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果       
              type: 'shadow'
            }
          },
          // 图表边界控制
          grid: {
            // 距离 上右下左 的距离
            left: '1%',
            right: '5%',
            bottom: '4%',
            top: '25%',
            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
          },
          // 控制x轴
          xAxis: [
            {
              data: d,
              // 使用数据的值设为刻度文字
              type: 'category',
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: true,
                show: false
              },
              //文字
              axisLabel: {
                color: "#667079",
                interval: 0,
                fontSize: 9,
                formatter: function (params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 15;
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                  if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = "";
                      var start = p * provideNumber;
                      var end = start + provideNumber;
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        tempStr = params.substring(start, end) + "\n";
                      }
                      newParamsName += tempStr;
                    }

                  } else {
                    newParamsName = params;
                  }
                  return newParamsName
                }
              },

              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
            }


          ],
          // 控制y轴
          yAxis: [
            {
              name: '台', 
              nameTextStyle: {
                fontSize: 9,
                lineHeight: 0,
                color:'#8B99A6',
                rich: {
                  a: {
                    // 没有设置 `lineHeight`，则 `lineHeight` 为 56
                  }
                }
              },
              // 使用类目，必须有data属性
              type: 'value',
              // 使用 data 中的数据设为刻度文字
              max: function (value) {
                return value.max + 100;
              },
              axisLabel: {
                color: "#667079",
                interval: 0,
                fontSize: 9,
                formatter: function (params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 15;
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                  if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = "";
                      var start = p * provideNumber;
                      var end = start + provideNumber;
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        tempStr = params.substring(start, end) + "\n";
                      }
                      newParamsName += tempStr;
                    }

                  } else {
                    newParamsName = params;
                  }
                  return newParamsName
                }
              },

              // 刻度设置
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: true,
                show: false
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },

            }
          ],
          color: ['#1e74bb', '#58b6df', '#cb8429'], //柱子颜色
          // 控制x轴
          series: [
            {
              // series配置
              showBackground: true,
              // 图表数据名称
              name: '配电箱',
              stack: 'total',
              barWidth: 10, // 柱子宽度
              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: [22, 71, 45,35,15,25,27]
            },
            {
              // series配置
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              // 图表数据名称
              name: '开关柜',
              stack: 'total',
              barWidth: 8, // 柱子宽度
              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: [22, 21, 15,45,35,25,35]
            } 
          ]
        };
        let names = '月出货量.标箱, 月出货量.非标箱, 月出货量.动力柜, 月出货量.低压柜, 月出货量.高压柜'
        // let names = 'ceshi1, demo1'
        let date = new Date().getTime()
        this.$api.manufacturingKanbanApi.getListByNames(names, date, res => {
          option.series = []
          res.map((v, i) => {


            var d = [];
            var data = []
            for (const key in v) {
              if (key.indexOf('value') === 0) {
                d.push(v[key]);//保存值
                data.push(key.substring(4))//保存键值对
              }
            }
            var d = {
              // series配置
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              // 图表数据名称
              name: v.name.substring(v.name.indexOf('.') + 1),
              stack: 'total',
              barWidth: 8, // 柱子宽度
              // 图表类型
              type: 'bar',
              barGap: 0,
              // 数据
              data: d
            }
            option.series.push(d);
          })

          
          this.$refs.vchart1.setData(option, true);
        })
        this.$refs.vchart1.setData(option, true);



      },

      // 负荷曲线
      curve() {
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '18%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00',],
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: true,
                show: false
              },
              //文字
              axisLabel: {
                color: "#667079",
                interval: 0,
                fontSize: 9,
                formatter: function (params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 15;
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                  if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = "";
                      var start = p * provideNumber;
                      var end = start + provideNumber;
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        tempStr = params.substring(start, end) + "\n";
                      }
                      newParamsName += tempStr;
                    }

                  } else {
                    newParamsName = params;
                  }
                  return newParamsName
                }
              },

            }
          ],
          yAxis: [
            {
              name: 'kw',
              type: 'value',
              boundaryGap: false, 
              max: function (value) {
                return value.max + 100;
              },
              nameTextStyle: {
                fontSize: 9,
                lineHeight: 0,
                color:'#8B99A6',
                rich: {
                  a: {
                    // 没有设置 `lineHeight`，则 `lineHeight` 为 56
                  }
                }
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
              //文字
              axisLabel: {
                color: "#667079",
                interval: 0,
                fontSize: 9,
                formatter: function (params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 15;
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                  if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = "";
                      var start = p * provideNumber;
                      var end = start + provideNumber;
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        tempStr = params.substring(start, end) + "\n";
                      }
                      newParamsName += tempStr;
                    }

                  } else {
                    newParamsName = params;
                  }
                  return newParamsName
                }
              },

            }
          ],
          color: ['#0B6FF7'],
          series: [
            {
              type: 'line',
              stack: 'Total',
              smooth: true, 
              showSymbol: false,
              areaStyle: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#0d5ecb'
                  }, 
                  {
                    offset: 1,
                    color: 'rgba(27, 30, 31,0)'
                  }
                ])
              },
              emphasis: {
                focus: 'series'
              },
              data: [120, 132, 101, 134, 90, 230, 210, 90, 240, 110, 240, 110]
            }

          ]
        };
        this.$refs.curve1.setData(option, true);
      },

      // 在产数量
      zaichanNum() {

      },


      // 同期对比
      comparing() {


        var option = {


          color: ["#0269e9", "#a1f3fc", "#01f5f6", "#00cfff"],
          series: [
            {
              name: "在产数量",
              type: 'pie',
              radius: ['60%', '78%'],
              center: ['50%', '49%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderColor: '#010305',
                borderWidth: 2
              },
              label: {
                show: false,
                formatter: '{b}\n{d}%',
                color: '#fff',//字体颜色  
                fontSize: 12,
              },
              emphasis: {
                label: {
                  show: false,
                  formatter: '{b}\n{d}%',
                  fontSize: '16',

                }
              },


              data: [
                { value: 589, name: '配电箱' },
                { value: 589, name: '配电箱' },
                { value: 325, name: '高压柜' },
                { value: 265, name: '低压柜' },
              ]
            }
          ]
        };
        this.$refs.comparing1.setData(option, true);
      },

      // 定单
      dingdan() {
        var data = {
          day365: { orders: '20,301,987', amount: '99834' },
          day90: { orders: '301,987', amount: '9834' },
          day30: { orders: '1,987', amount: '3834' },
          day1: { orders: '987', amount: '834' }
        }
        //点击事件
        $('.order').on('click', '.filter a', function () {
          //点击之后加类名
          $(this).addClass('active').siblings().removeClass('active');
          // 先获取点击a的 data-key自定义属性
          var key = $(this).attr('data-key');
          //获取自定义属性
          // data{}==>data.shuxing data['shuxing]
          key = data[key];//
          $('.order .item h4:eq(0)').text(key.orders);
          $('.order .item h4:eq(1)').text(key.amount);
        });
        //定时器
        var index = 0;
        var aclick = $('.order a');
        setInterval(function () {
          index++;
          if (index > 3) {
            index = 0;
          }
          //每san秒调用点击事件
          aclick.eq(index).click();
        }, 3000);
      },

    },
  };
</script>

<style>
  	@import url("../../components/font/fontStyle.css");

    /* .li_box .chart .vchart1{ 
  background: url('../../assets/kanban/yue_bg.png') no-repeat;
  background-position: -19px 6px;
    background-size: 107.6% 103.4%;
} */
    .li_box .chart .bgc{ 
      position: absolute; 
      display: flex;
    z-index: 1;
    width: 76%; 
    justify-content: space-between;
    left: 0.632rem;
    bottom: 0.61rem;
}
.li_box .chart .bgc span{
  width: 0.123rem;
    height: 0.94rem;
    background: #000;
}

 .li_box3 .hetong .Unfilled1{
    height: 1.7rem;
    background: url('../../assets/kanban/hetong.png') no-repeat;
    background-position: 0.2rem 0.37rem;
    background-size: 76.6% 64.4%;
}
  .li_box3 .hetong  .Unfilled2{
    height: 1.7rem;
    background: url('../../assets/kanban/ding_bg.png') no-repeat;
    background-position: 0.2rem 0.37rem;
    background-size: 70% 64%;
}
  .progress_box svg path:first-child {
    stroke: none;
  }

  /* 在产数量 */
  .zaichan {
    padding: .1rem;
    padding-top: .2rem;
  }

  .titled {
    display: flex;
    font-size: 11px;
    color: #fff;
  }

  .titled .n {
    margin-left: .2rem;
    font-family: 'SourceHanSansCN-Regular';
    color: #d3d1d1;
  }

  .titled .t {
    margin-left: .1rem;
    font-size: .22rem;
    font-family: 'Acens-1';
    color: #1980D6;
    letter-spacing: 2px;
    word-spacing: -7px;
  }

  .titled .t>i {
    font-size: .12rem;
    color: #fff;
    font-style: normal;
    display: inline-block;
    margin-left: .04rem;
  }

  .zaichan .content {
    display: flex;
    justify-content: center;
    margin-top: 0.15rem;
  }

  .zaichan .content>div {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: .11rem;
    color: #ADADAD;
  }

  .zaichan .content>div .name {
    margin-top: .03rem;
  }

  .zaichan .content .progress_box {
    width: 84px;
    height: 84px;
    background: url('../../assets/kanban/zc.png');
    background-position: 0px 0px;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  /* 在产数量 */
  .li_box {
    display: inline-block;
    width: 4.75rem;
    height: 2.12rem;
    background: url('../../assets/kanban/ychlbg.png');
    background-position: 0px 0px;
    background-size: 100% 100%;
  }

  .li_box2 {
    display: inline-block;
    width: 100%;
    height: 1.96rem;
    background: url('../../assets/kanban/zcbg.png');
    background-position: 0px 0px;
    background-size: 100% 100%;
  }
  .li_box22 {
    display: inline-block;
    width: 100%;
    height: 1.96rem;
    background: url('../../assets/kanban/bgc.png');
    background-position: 0px 0px;
    background-size: 100% 100%;
  }

  .li_box3 {
    display: inline-block;
    width: 100%;
    height: 2.15rem;
    background: url('../../assets/kanban/bg3.png');
    background-position: 0px 0px;
    background-size: 100% 100%;
  }
  .li_box4 {
    display: inline-block;
    width: 100%;
    height: 2.15rem;
    background: url('../../assets/kanban/tongqi_bg.png');
    background-position: 0px 0px;
    background-size: 100% 100%;
  }

  .li_box3 .hetong {
    box-sizing: border-box;
    display: flex;
    height: 100%;
    padding: .2rem;
    padding-right: .1rem;
  }

  .li_box3 .hetong .left {
    width: 4.8rem;
    margin-right: .4rem;
  }

  .li_box3 .hetong .right {
    flex: 1;
  }

  .li_box .content {
    box-sizing: border-box;
    padding: 0.1rem;
    padding-right: 0.2rem;
  }

  .li_box .chart {
    box-sizing: border-box;
    height: 100%;
    padding: .1rem .2rem;
    padding-top: .17rem;
    position: relative;
  }

  .li_box .chart .bottomd {
    font-family: 'SourceHanSansCN-Medium';
    color: #d3d1d1;
  }

  .li_box .chart .bottomd span {
    font-size: 12px;
    transform: scale(.7);
    display: inline-block;
    margin-right: 2px;
    font-family: 'SourceHanSansCN-Light';
    width: .34rem; 
    text-align: center;
    margin-right: -2px;
    white-space: nowrap;
  }

  .li_box .chart .bottomd span img {
    width: 6px;
  }



  html * {
    user-select: text !important;
  }

  .column .map {
    position: relative;
    height: 95.3%;
  }

  .column .map .LowerRightCorner {
    position: absolute;
    right: .1rem;
    bottom: .08rem;
    background: url('../../assets/kanban/xuqiu.png');
    width: 2.51rem;
    height: 1.03rem;
    background-position: 0px 0px;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    color: #FFF;
    font-size: .11rem;
    justify-content: space-around;
    box-sizing: border-box;
    padding: 0.15rem 0.2rem;
    font-family: 'SourceHanSansCN-Regular';
    opacity: .8;
    padding-left: .05rem;
  }

  .column .map .LowerRightCorner .p {
    display: flex;
  }

  .column .map .LowerRightCorner .n {
    width: 1rem;
    text-align: right;
    margin-right: 0.15rem;
    font-family: 'SourceHanSansCN-Regular'; 
    letter-spacing: .01rem;
  }

  .column .map .LowerRightCorner .t {
    font-size: .19rem; 
    color: #1980D6;
    flex: 1;
    position: relative;
  
  }
  .column .map .LowerRightCorner .t span {
    letter-spacing: 1px;
    font-family: Acens-1;
    font-size: .19rem; 
    font-weight: 400;
  }
  .column .map .LowerRightCorner i{
    position: absolute;
    right: 0;
    display: inline-block;
    width: 0.8rem;
    color: #fff;
    text-align: right;
    font-style: normal;
    font-family: 'SourceHanSansCN-Regular';
  } 


  .column .map .m_box {
    position: absolute;
    top: 0;
    left: 0;
  }

  .column .map .m_box .li {
    width: 2.14rem;
    height: .98rem;
    background: #1B1B1B;
    border: 1px solid #BFBFBF;
    opacity: 0.82;
    margin-top: 0.2rem;
    margin-left: 0.55rem;
    position: relative;
  }

  .column .map .m_box .li .left {
    position: absolute;
    left: -1px;
    top: -1px;
    width: 0.2rem;
    height: 0.22rem;
    border-top: 1px solid #0B71F7;
    border-left: 1px solid #0B71F7;
  }

  .column .map .m_box .li .right {
    position: absolute;
    right: -1px;
    bottom: -1px;
    width: 0.2rem;
    height: 0.22rem;
    border-right: 1px solid #0B71F7;
    border-bottom: 1px solid #0B71F7;
  }

  .column .map .m_box .t {
    line-height: .35rem;
    font-size: .21rem;
    font-family: 'SourceHanSansCN-Regular';
    font-weight: 400;
    color: #FFF;
    padding-left: .24rem;
    margin-top: .03rem;
  }

  .column .map .li .x {
    display: flex;
    justify-content: space-between;
    padding: 0 .2rem;
    margin-top: .2rem;
    align-items: center;
  }

  .column .map .li .x span {
    font-size: .25rem;
    font-family: 'SourceHanSansCN-Light';
    font-weight: 300; 
    color: #FFF;
    /* padding-right: .12rem; */
  }

  .column .map .li .x .txt {
    font-size: .33rem;
    font-family: 'Acens-1'; 
    color: #1980D6; 
    letter-spacing: 2px;
    font-weight: 400;
    word-spacing: -7px;
  }

  /* 同期对比 */
  .comparing .span {
    position: absolute;
    color: #fff;
    left: 0.66rem;
    top: 0.7rem;
    font-size: .2rem;
    font-family: 'SourceHanSansCN-Light'; 
    width: 0.7rem;
    text-align: center;
  }

  .comparing .span i {
    font-family: 'SourceHanSansCN-Light';
    font-style: initial;
    display: inline-block;
    font-size: .2rem;
    -webkit-transform: translate(11px, -13px);
    transform: translate(5px, -13px);
  }

  .comparing {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .comparing .left {
    width: 2.1rem;
    margin-right: .1rem;
    position: relative;
  }

  .comparing .left .tit {
    display: flex;
    justify-content: center;
    font-size: .17rem;
    font-family: 'SourceHanSansCN-Regular';
    font-weight: 400;
    color: #d3d1d1;
  }

  .comparing .left .tit .txt {
    font-size: .25rem; 
    font-weight: normal;
    color: #1980D6;
    margin-left: .1rem;
    font-family: 'Acens-1';
    margin-right: 0.02rem;
    transform: translateY(-2px);
    letter-spacing: 2px;
  }

  .comparing .right {
    display: flex;
    color: #d3d1d1;
    flex-wrap: wrap;
    flex: 1; 
  }

  .comparing .right .li {
    display: flex;
    flex-direction: column;
    width: 3.3rem;
  }

  .comparing .right .li:nth-child(1) {
    box-sizing: border-box;
    border-right: 1px solid #5F6162;
    border-bottom: 1px solid #5F6162;
    padding-bottom: 10px;
    padding-right: 0.17rem;
  }

  .comparing .right .li:nth-child(2) {
    box-sizing: border-box;
    border-bottom: 1px solid #5F6162;
    padding-bottom: 10px;
    padding-left: 13px;
  }

  .comparing .right .li:nth-child(3) {
    box-sizing: border-box;
    border-right: 1px solid #5F6162;
    padding-top: 10px;
    padding-right: 0.17rem;
  }

  .comparing .right .li:nth-child(4) {
    padding-top: 10px;
    padding-left: 13px;
    box-sizing: border-box;
  }

  .comparing .right .li .t {
    display: flex;
    margin-bottom: .06rem;
  }

  .comparing .right .li .t .n {
    width: 1.5rem;
    font-size: .17rem;
    font-family: 'element-icons';
    font-weight: 400;
    color: #d3d1d1;
  }

  .comparing .right .li .t .ll {
    width: 2.6rem;
    height: 24px;
    background: #101215;
    font-size: .13rem;
    font-family: 'SourceHanSansCN-Regular';
    font-weight: 400;
    color: #F1F1F1;
  }

  .comparing .right .li .t .ll .nn {
    font-size: .13rem;
    font-family: 'SourceHanSansCN-Regular';
    font-weight: 400;
    padding-left: .1rem;
    width: 1rem;
    display: inline-block;
  }

  .comparing .right .li .t .ll .nt {
    font-size: 17px;
    font-family: 'SourceHanSansCN-Regular';
    font-weight: 400;
    color: #1980D6;
  }

  .comparing .right .li .t .ll .nt .ren {
    font-size: .12rem;
    color: #F1F1F1;
    font-family: 'Lato-Regular-2';
  }
  .comparing .right .li .t .ll .n .ren {
    font-family: 'Lato-Regular-2';
  }

  .comparing .right .li .t .txt {
    font-size: .17rem;
    font-family: 'Lato-Regular-2';
    font-weight: 400;
    color: #1980D6;
  }

  .comparing .right .li .t .txt .ren {
    font-size: .16rem;
  }




  /* 区域能耗 */
  .Itemized {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    box-sizing: border-box;
    height: 100%;
    padding: .17rem 0;
  }

  .Itemized .p {
    display: flex;
    box-sizing: border-box;
    font-size: 13px;
    font-family: 'SourceHanSansCN-Medium';
    font-weight: 400;
    color: #bcbebf;
    align-items: center;
    justify-content: space-between;
    padding-left: 0.17rem;
    padding-right: 0.34rem;
  }

  .Itemized .p:nth-child(2) .jindu .n {
    background: #57cfff;
  }

  .Itemized .p:nth-child(3) .jindu .n {
    background: #a2f6fe;
  }

  .Itemized .p:nth-child(4) .jindu .n {
    background: #cb8429;
  }

  .Itemized .p:nth-child(5) .jindu .n {
    background: #1ab49c;
  }

  .Itemized .p:nth-child(6) .jindu .n {
    background: #01aeff;
  }

  .Itemized .p .name {
    width: 0.83rem;
    text-align: right;
    margin-right: 0.16rem;
    font-family: 'SourceHanSansCN-Regular';
    color: #bcbebf;
  }

  .Itemized .p .jindu {
    width: 63%; 
    background: #101215;
    height: 10px;
    margin-right: 10px;
  }

  .Itemized .p .jindu .n {
    background: #0b71f7;
    height: 10px;
    width: 50%;
  }
  .Itemized .p .text {
   font-family: 'Lato-Regular-2';
   color: #bcbebf;
  }

  /* 用能概况 */
  .situation {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    box-sizing: border-box;
    padding: 0.15rem 0.15rem;
    padding-top: 0.3rem;
  }

  .situation .p {
    display: flex;
    color: #d3d1d1;
    flex-direction: column;
    margin: 0 9px;
    padding-left: 25px;
    padding-right: 50px;
    border-bottom: 1px solid #5F6162;
  }

  .situation .p:nth-last-child(1) {
    border-bottom: none;
  }

  .situation .p div {
    display: flex;
    font-family: 'Lato-Regular-2';
  }

  .situation .p .top {
    height: auto;
    justify-content: space-between;
    height: .25rem;
  }

  .situation .p .bottom {
    font-size: .12rem;
    font-family: 'SourceHanSansCN-Light';
    font-weight: 300;
    color: #95A4B2;
    margin-bottom: 0.05rem;
  }

  .situation .p .l {
    font-size: .17rem;
    font-family: 'SourceHanSansCN-Regular';
    font-weight: 400;
    color: #bcbebf;
    margin-bottom: .07rem;
  }

  .situation .p .m {
    line-height: .26rem;
  }

  .situation .p .m .txt {
    font-size: .21rem;
    font-family: 'Lato-Regular-2';
    font-weight: 400;
    color: #1980D6;
    line-height: .21rem;
  }

  .situation .p .r {
    width: 27%;
    height: 23px;
    background: #101215;
    color: #EF9E35;
    align-items: center;
    justify-content: space-around;
  }

  .situation .p .Reverse {
    color: #1AB49C;
  }

  .situation .p .none {
    color: #8B99A6;
  }

  .situation .p .Reverse .n:nth-child(2) {
    transform: rotate(180deg);
  }

  /* 在产数量 */
  .inner .xianshi {
    position: absolute;
    color: #fff;
    left: 22px;
    top: 15px;
    display: flex;
    flex-direction: column;
    line-height: 30px;
  }

  .inner .xianshi .p {
    display: flex;
    font-size: .13rem;
    font-family: 'SourceHanSansCN-Medium';
    font-weight: 400;
    color: #FFF;
    height: .23rem;
    align-items: center;
  }

  .inner .xianshi .p .txt {
    color: #1980D6;
    font-size: .21rem;
    padding: 0 .07rem;
    width: 48px;
    text-align: right;
  }

  .li {
    display: block;
  }

  .li .li_tit {
    display: flex;
    margin-bottom: .06rem;
    align-items: flex-end;
  }

  .li .li_tit .name {
    font-size: .22rem;
    font-family: 'SourceHanSansCN-Medium';
    font-weight: 500;
    color: #1980D6;
    line-height: 29px;
    margin-right: .19rem;
    transform: translateY(3px);
    padding-left: .05rem;
  }

  .li .li_tit .txt {
    font-size: .14rem;
    font-family: 'SourceHanSansCN-Medium';
    font-weight: 500;
    font-style: italic;
    color: #4A545D;
  }

  /* 头部 */
  .box_title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 10px;
  }

  .box_title .right {
    font-size: .16rem;
    font-family: 'SourceHanSansCN-Medium';
    font-weight: 300;
    color: #FFF;
    width: 4.74rem;
    display: flex;
    align-items: end;
    justify-content: space-between;
  }

  .box_title .right span {
    font-size: .16rem;
    font-family: 'SourceHanSansCN-Light';
    font-weight: 300;
  }

  /* .box_title .left {
    font-size: .32rem;
    font-family: lianmengqiyilushuaizhengruiheiti;
    font-weight: 400;
    color: #1980D6;
    border-bottom: 1px solid #1980D6;
    line-height: .44rem;
  } */


  .chart_box {
    display: flex;
  }

  .chart_box>.pare {
    flex: 1;
  }

  .chart_box>.progress {
    width: 40%;
  }

  .chart_box>.progress2 {
    width: 40%;
  }

  .chart_box .progress .text {
    display: flex;
    justify-content: space-between;
    margin-bottom: .45px;
  }

  .chart_box .progress .text span {
    color: #fff;
  }

  .chart_box .progress .el-progress {
    margin-bottom: 19.5px;
  }

  .bottom_box {
    display: flex;
    overflow: hidden;
    justify-content: space-between;
  }

  .bottom_box1 .li:nth-child(1) {
    width: 4.74rem;
  }

  .bottom_box1 .li:nth-child(2) {
    width: 8.38rem;
  }

  .bottom_box1 .li:nth-child(3) {
    width: 4.74rem;
  }

  .bottom_box .panel {
    flex: 1;
    margin-right: 12.495px;
  }

  .bottom_box .panel:nth-child(2) {
    margin-right: 0;
  }

  .bodyed {
    display: block;
    line-height: 1.15;
    font-size: 7.5px;
    margin: 0;
    padding: 0;
    width: 19.2rem;
    overflow-x: hidden;
    background-repeat: no-repeat;
    background-position: 0 0 / cover;
    background-color: #010305;
  }

  .bodyed>.box {
    display: block;
    /* max-width: 1920px; */
    margin: 0 auto;
    padding: 0 .3rem;
  }

  * {
    margin: 0;
    padding: 0;
    font-weight: normal;
  }

  ul {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  .viewport {
    /* 限定大小 */
    min-width: 1024px;
    /* max-width: 1920px; */
    margin: 0 auto;
    display: flex;
    padding-top: .1rem;
    justify-content: space-between;
  }

  .column {
    /* flex: 3; */
    width: 4.74rem;
    position: relative;
  }

  .column:nth-child(2) {
    /* flex: 4; */
    width: 8.38rem;
  }

  .panel {
    /* 边框 */
    box-sizing: border-box;
    border: 2px solid #ff000000;
    border-top-width: 21px;
    border-right-width: 16px;
    border-bottom-width: 9px;
    border-left-width: 59px;
    position: relative;
    /* margin-bottom: 12.495px; */
  }

  .panel_box {
    width: 30%;
    height: 49.5px;
    padding-top: .45px;
    box-sizing: border-box;
    border: solid 1px #093552;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 10px 23px #03729724 inset;

  }

  .panel .inner {
    /* 装内容 */
    /* height:60px;*/
    position: absolute;
    top: -23.875px;
    right: -19.745px;
    bottom: -11.125px;
    left: -60.5px;
    padding: 13px 12px;
    display: flex;
    flex-direction: column;
    background: url('../../assets/kanban/box.png');
    background-position: 0px 0px;
    background-size: 100% 100%;
  }

  .panel .inner2 {
    background: url('../../assets/kanban/box2.png');
    background-position: 2px -1px;
    background-size: 99.3% 100.9%;
  }

  .panel h3 {
    color: #fff;
    display: flex;
    padding-left: 55px;
    font-size: 14px;
    font-family: 'SourceHanSansCN-Medium';
    font-weight: 400;
    color: #d3d1d1;
  }

  .panel h3 .txt {
    font-size: 19px;
    font-family: Lato;
    font-weight: 400;
    color: #1980D6;
    padding-left: 10px;
  }

  /* 概览区域 */
  .overview {
    height: 68.745px;
  }

  .overview .inner {
    display: flex;
    justify-content: space-between;
  }

  .overview h4 {
    font-size: .135px;
    padding-left: 3px;
    color: #fff;
    margin-bottom: 4.995px
  }

  .overview span {
    font-size: 13.005px;
    color: #4c9bfd;
    margin-bottom: .45px;
  }



  .monitor .inner {
    padding: 15px 0;
    display: flex;
    flex-direction: column;
  }

  .monitor .tabs {
    padding: 0 22.5px;
    margin-bottom: 11.25px;
  }

  .monitor .tabs a {
    color: #1950c4;
    font-size: 11.25px;
    padding: 0 16.875px;
  }

  .monitor .tabs a:first-child {
    border-right: 1.245px solid #00f2f1;
    padding-left: 0;
  }

  .monitor .tabs a.active {
    color: #fff;
  }

  .monitor .content {
    flex: 1;
    display: none;
    position: relative;
  }

  .monitor .head {
    background: rgba(255, 255, 255, 0.1);
    font-size: 8.745px;
    padding: 7.5px 22.5px;
    color: #68d8fe;
    display: flex;
    justify-content: space-between;
    line-height: 1.05;
  }


  .monitor .col:nth-child(2) {
    width: 126px;
    /* 不换行 一行省略*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .monitor .col:nth-child(3) {
    width: 48px;
  }

  .monitor .marquee-view {
    position: absolute;
    top: .90px;
    bottom: 0;
    width: 100%;
    overflow: hidden;
  }

  /* 质量情况 */
  .marquee-view2 {
    color: #bcbebf;
    font-size: .12rem;
    padding-right: 0.08rem
  }

  .marquee-view2 .li {
    display: flex;
    justify-content: space-between;
    margin-top: .05rem;
  }

  .marquee-view2 .li:nth-child(1)>span {
    background: none;
    color: #bcbebf;
    margin-bottom: 1px;
  }

  .marquee-view2 .li>span {
    width: 1.17rem;
    background: #000;
    text-align: center;
    padding: 1.5px 0;
    color: #1980D6;
    font-size: 11px;
    font-family: 'Lato-Regular-2';
  }

  .marquee-view2 .li>span:nth-child(1) {
    background: none;
    width: .6rem;
    color: #bcbebf;
    text-align: right;
  }

  /* 质量情况 */



  .monitor .row:nth-child(even) {
    background: #101215;
  }

  .monitor .row .col {
    font-size: 13px;
  }

  .monitor .row .col:nth-child(2) {
    color: #187ACD;
    text-indent: 3em;
  }

  .monitor .row:hover {
    color: #68d8ff;
    background: rgba(255, 255, 255, 0.1);
  }

  .monitor .row:hover .fa-arrow-up {
    opacity: 1;
  }

  .monitor .fa-arrow-up {
    position: absolute;
    left: 9.6px;
    opacity: 0;
  }

  .monitor .marquee-view {
    position: absolute;
    top: .90px;
    bottom: 0;
    width: 100%;
    overflow: hidden;
  }

  .monitor .row {
    line-height: 1.05;
    padding: 7.5px 22.5px;
    color: #DBDBDB;
    font-size: 7.5px;
    position: relative;
    display: flex;
    justify-content: space-between;
    padding-left: 55px;
  }

  .monitor .row:hover {
    color: #68d8ff;
    background: rgba(255, 255, 255, 0.1);
  }

  .monitor .row:hover .fa-arrow-up {
    opacity: 1;
  }

  .monitor .fa-arrow-up {
    position: absolute;
    left: 9.6px;
    opacity: 0;
  }

  /* ------------------------------------------------------------动画 */
  @keyframes row {
    0% {}

    100% {
      transform: translateY(-50%);
    }
  }

  /* 调用动画 */
  .monitor .marquee {
    /* //infinite永久调用动画 */
    animation: row 10s linear infinite;
  }

  /*鼠标划入 停止动画 */
  .monitor .marquee:hover {
    animation-play-state: paused;
  }

  /* 点位 */
  .point {
    height: 180px;
  }

  .point .chart {
    display: flex;
    justify-content: space-between;
  }

  .point .pie {
    width: 100%;
    height: 147px;
    margin-left: -6px;
  }

  .point .data {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 105px;
    padding: 22.5px 18.75px;
    box-sizing: border-box;
    background-image: url('../../assets/kanban/rect.png');
    background-size: cover;
  }

  .point h4 {
    margin-bottom: 7.5px;
    font-size: 17.505px;
    color: #fff;
  }

  .point span {
    display: block;
    color: #4c9bfd;
    font-size: 10.005px;
  }


  /* 用户模块 */
  .users {
    height: 2.13rem;
    display: flex;
  }

  .users .chart {
    display: flex;
    margin-top: .75px;
    height: 100%;
  }

  .users .bar {
    width: 367.5px;
    height: 135px;
  }

  .users .data {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 105px;
    padding: 22.5px 18.75px;
    box-sizing: border-box;
    background-image: url('../../assets/kanban/rect.png');
    background-size: cover;
  }

  .users h4 {
    margin-bottom: 7.5px;
    font-size: 17.505px;
    color: #fff;
  }



  /* 订单 */
  .order {
    height: 92.505px;
  }

  .order .filter {
    display: flex;
  }

  .order .filter a {
    display: block;
    height: 11.25px;
    line-height: 1;
    padding: 0 11.25px;
    color: #1950c4;
    font-size: 11.25px;
    border-right: 1.245px solid #00f2f1;
  }

  .order .filter a:first-child {
    padding-left: 0;
  }

  .order .filter a:last-child {
    border-right: none;
  }

  .order .filter a.active {
    color: #fff;
    font-size: 12.495px;
  }

  .order .data {
    display: flex;
    margin-top: 12.495px;
  }

  .order .item {
    width: 50%;
  }

  .order h4 {
    font-size: 17.505px;
    color: #fff;
    margin-bottom: 6.255px;
  }

  .order span {
    display: block;
    color: #4c9bfd;
    font-size: 10.005px;
  }

  /* 销售区域 */
  .sales {
    height: 180px;
  }

  .sales .caption {
    display: flex;
    line-height: 1;
  }

  .sales h3 {
    height: 11.25px;
  }

  .sales .chart {
    flex: 1;
    padding-top: 9px;
    position: relative;
  }

  .sales .label {
    position: absolute;
    left: 26.25px;
    top: 11.25px;
    color: #4996f5;
    font-size: 8.745px;
  }

  .sales .line {
    width: 100%;
    height: 100%;
  }

  /* 渠道区块 */
  .wrap {
    display: flex;
  }

  .channel,
  .quarter {
    flex: 1;
    height: 145.005px;
  }

  .channel {
    margin-right: 12.495px;
  }

  .channel .data {
    overflow: hidden;
  }

  .channel .item {
    margin-top: 12.75px;
  }

  .channel .item:first-child {
    float: left;
  }

  .channel .item:last-child {
    float: right;
  }

  .channel h4 {
    color: #fff;
    font-size: 19.995px;
    margin-bottom: 3px;
  }

  .channel small {
    font-size: 50%;
  }

  .channel span {
    display: block;
    color: #4c9bfd;
    font-size: 8.745px;
  }

  /* 季度区块 */
  .quarter .inner {
    display: flex;
    flex-direction: column;
    margin: 0 -3.75px;
  }

  .quarter .chart {
    flex: 1;
    padding-top: 11.25px;
  }

  .quarter .box {
    position: relative;
  }

  .quarter .label {
    transform: translate(-50%, -30%);
    color: #fff;
    font-size: 18.75px;
    position: absolute;
    left: 50%;
    top: 50%;
  }

  .quarter .label small {
    font-size: 50%;
  }

  .quarter .gauge {
    height: 52.5px;
  }

  .quarter .data {
    display: flex;
    justify-content: space-between;
  }

  .quarter .item {
    width: 50%;
  }

  .quarter h4 {
    color: #fff;
    font-size: 15px;
    margin-bottom: 6px;
  }

  .quarter span {
    display: block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #4c9bfd;
    font-size: 8.745px;
  }

  /* 排行榜 */
  .top {
    height: 177px;
  }

  .top .inner {
    display: flex;
  }

  .top .all {
    display: flex;
    flex-direction: column;
    width: 105px;
    color: #4c9bfd;
    font-size: 9px;
    vertical-align: middle;
  }

  .top .all i {
    font-size: 21px;
  }

  .top .all ul {
    padding-left: 7.5px;
    margin-top: 7.5px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .top .all li {
    overflow: hidden;
  }

  .top .all [class^="icon-"] {
    font-size: 22.5px;
    vertical-align: middle;
    margin-right: 7.5px;
  }

  .top .province {
    flex: 1;
    display: flex;
    flex-direction: column;
    color: #fff;
  }

  .top .province i {
    padding: 0 7.5px;
    margin-top: 3.12px;
    float: right;
    font-style: normal;
    font-size: 8.745px;
    color: #0bace6;
  }

  .top .province s {
    display: inline-block;
    transform: scale(0.8);
    text-decoration: none;
  }

  .top .province .fa-arrow-up {
    color: #dc3c33;
  }

  .top .province .fa-arrow-down {
    color: #36be90;
  }

  .top .province .data {
    flex: 1;
    display: flex;
    margin-top: 9px;
  }

  .top .province ul {
    flex: 1;
    line-height: 1;
    margin-bottom: 3.75px;
  }

  .top .province ul li {
    display: flex;
    justify-content: space-between;
  }

  .top .province ul span {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .top .province ul.sup {
    font-size: 8.745px;
  }

  .top .province ul.sup li {
    color: #4995f4;
    padding: 7.5px;
  }

  .top .province ul.sup li.active {
    color: #a3c6f2;
    background-color: rgba(10, 67, 188, 0.2);
  }

  .top .province ul.sub {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 7.5px;
    background-color: rgba(10, 67, 188, 0.2);
  }

  .top .province ul.sub li {
    color: #52ffff;
    padding: 6.255px 9px;
  }

  .clock {
    position: absolute;
    top: -22.5px;
    right: 25.005px;
    font-size: 12.495px;
    color: #0bace6;
  }

  .clock i {
    margin-right: 5px;
    font-size: 12.495px;
  }

  @media screen and (max-width:1600px) {
    .top span {
      transform: scale(0.9);
    }

    .top .province ul.sup li {
      padding: 6px 7.5px;
    }

    .top .province ul.sub li {
      padding: 3.45px 7.5px;
    }

    .quarter span {
      transform: scale(0.9);
    }
  }
</style>